<div sessionTimeout>
    <router-outlet></router-outlet>
</div>